/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    FilterRecruitsGroupwise : null,
    RecruitGroupCount:null,
    masterReferralCodes : null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.RecruitsGroupAction.REQUEST_RECRUITSGROUPDATA:
      return {
        ...state,
    };
    case actions.RecruitsGroupAction.RECRUITSGROUPDATA_RECEIVED:
          return{
      ...state,
      FilterRecruitsGroupwise : action.data.filterRecruitsGroupwise,
      RecruitGroupCount:action.data.GroupwiseRecruitedCount,
      masterReferralCodes:action.data.masterReferralCodes,
      // userid: action.payload.user_ID,
      // projectid: action.payload.project_ID,
    };

    default:
      return state;
  }
};

export default reducer;
